export enum EResource {
  CLIENT = 'client',
  USER = 'user',
  ACTIVITY = 'activity',
  MOVEMENT = 'movement',
  NOTICE = 'notice',
  TEAM = 'team',
  PROTECTION_TYPE = 'protectionType',
  PROTECTION_ZONE = 'protectionZone',
  PROTECTION = 'protection',
  GEO_MARKER = 'geoMarker',
  POINT_ACCESS = 'pointAccess',
  SUB_SECTOR = 'subSector',
  TRAIN_STATION = 'trainStation',
  SWITCH = 'switch',
  AUTHORIZED_CONFLICT = 'authorizedConflict',
  DICTIONARY = 'dictionary',
  SECTOR = 'sector',
  TRACK = 'track',
  JUNCTION = 'junction',
  TRAIN_STATION_DAILY_STATUS = 'trainStationDailyStatus',
  TRAIN_STATION_DAILY_NOTES = 'trainStationDailyNotes',
  RESOURCE = 'resource',
  RESOURCE_ROLE = 'resourceRole',
  NETWORK = 'network',
}

export enum EPermission {
  CAN_VIEW = 'canView',
  CAN_VIEW_ASSIGNED = 'canViewAssigned',
  CAN_CREATE = 'canCreate',
  CAN_UPDATE = 'canUpdate',
  CAN_UPDATE_OWN = 'canUpdateOwn',
  CAN_DELETE = 'canDelete',
  CAN_DELETE_OWN = 'canDeleteOwn',
  CAN_APPROVE = 'canApprove',
}

export type TResourcePermissions = {
  canView: boolean
  canViewAssigned: boolean
  canCreate: boolean
  canUpdate: boolean
  canUpdateOwn: boolean
  canDelete: boolean
  canDeleteOwn: boolean
  canApprove: boolean
}

export type TPermissionResponse = {
  [key in EResource]: TResourcePermissions
}
